/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * One block of one language, as the agent reports it.
 */
export interface TranslateJobAdOutcome {
  templateId?: string | null;
  /**
   * The template item the block answers to; lines up with `SourceTemplateItemId` on the content.
   */
  itemId?: string | null;
  languageCode?: string | null;
  status?: TranslateJobAdOutcomeStatusEnum;
  /**
   * The agent\'s explanation; set only when SiemensEnergy.COIN.Client.Api.Models.HeadcountApproval.JobAd.TranslateJobAdOutcomeModel.Status is Failed.
   */
  error?: string | null;
}
export enum TranslateJobAdOutcomeStatusEnum {
  Filled = 'Filled',
  Unchanged = 'Unchanged',
  Failed = 'Failed'
}
